module.exports = __webpack_public_path__ + "img/img-1.293b66f0.png";